import React from 'react';
import { connect } from 'react-redux';

import withStyles from '@mui/styles/withStyles';

import { setApiResponseInfo } from '../store/slices/apiResponseInfoSlice';

import activityPanelStyles from '../assets/jss/crm/components/activityPanelStyles';

import ConfirmModal from './ConfirmModal';
import CrmButton from './CrmButton';
import CrmTextField from './CrmTextField';

/*
Call with
<FullSmsPanel
  sms={activity object for this sms}
  page={somebody that implements buildActivityGroupsFromReduxStore()}
  textDeletionFunc={function} // to delete the text and close the modal.
  closeEditorFunc={function}
/>
*/

class FullSmsPanel extends React.Component {
  state = {
    smsText: '',
  };

  componentDidMount() {
    const sms = this.props.sms;
    this.setState({ smsText: sms.content });
  }

  componentDidUpdate(prevProps) {
    const newSms = this.props.sms;
    const smsId = newSms.id;
    if (prevProps.sms.id !== smsId) {
      this.setState({ smsText: newSms.content });
    }
  }

  offerToDeleteNote() {
    const q = 'Are you sure you want to delete the record of this text?';
    this.setState({
      shouldShowDeletionConfirmationModal: true,
      deletionConfirmationQuery: q,
      deleteFunc: () => this.props.textDeletionFunc(),
    });
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <ConfirmModal
          show={this.state.shouldShowDeletionConfirmationModal}
          title="Confirm Deletion"
          confirmButtonLabel="Delete"
          rejectButtonLabel="Cancel"
          onConfirm={this.state.deleteFunc}
          onReject={() => this.setState({ shouldShowDeletionConfirmationModal: false })}
        >
          <div>{this.state.deletionConfirmationQuery}</div>
        </ConfirmModal>

        <div className={classes.activityPanel_content}>
          <CrmTextField label="Text Content" fullWidth multiline readOnly value={this.state.smsText} />
        </div>
        <div className={classes.u_alignRight}>
          <CrmButton filled onClick={() => this.offerToDeleteNote()}>
            Delete
          </CrmButton>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userInfo: state.userInfo,
});

const actionProducers = {
  setApiResponseInfo,
};

export default connect(mapStateToProps, actionProducers)(withStyles(activityPanelStyles)(FullSmsPanel));
